import { render } from "./HomePageFooter.vue?vue&type=template&id=7844db10&scoped=true"
const script = {}

import "./HomePageFooter.vue?vue&type=style&index=0&id=7844db10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7844db10"]])

export default __exports__